import apiService from 'util/apiService';
import {
    GET_CLIENTS_INFO_FAILURE,
    GET_CLIENTS_INFO_START,
    GET_CLIENTS_INFO_SUCCESS
} from "../constants/clients";

export const getClientsInfoStart = (payload) => ({
    type: GET_CLIENTS_INFO_START,
    payload,
});

export const getClientsInfoSuccess = (payload) => ({
    type: GET_CLIENTS_INFO_SUCCESS,
    payload,
});

export const getClientsInfoFailure = (payload) => ({
    type: GET_CLIENTS_INFO_FAILURE,
    payload,
});
export const getClientsList = (payload, callback) => {
    const { apiUrl } = payload;
    return (dispatch) => {
        dispatch(getClientsInfoStart())
        return apiService
            .get(apiUrl)
            .then((res) => {
                const { statusCode:code, messageCode, data } = res;
                if (code === 200) {
                    if(callback){
                        dispatch(callback(data))
                    }
                    dispatch(getClientsInfoSuccess(data));
                } else {
                    dispatch(getClientsInfoFailure(messageCode));
                }
            })
            .catch((err) => {
                dispatch(getClientsInfoFailure({ messageCode: err.message }));
            });
    };
};